/*******************************************************
 * Copyright (C) BoostCommerce.net
 *
 * This file is part of commercial BoostCommerce.net projects.
 *
 * This file can not be copied and/or distributed without the express
 * permission of BoostCommerce.net
 *
 * @Date:   2023-02-07 14:05:30
 *
 *******************************************************/
// @flow
//
import _ from 'lodash';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withI18n, WithI18nProps } from '@shopify/react-i18n';
import ReviewModal from './review-modal';
import StatusModal from 'src/components/views/subscription-v3/modal/status-modal';
import { exitSABFullscreen } from 'src/integrations/shopify-app-bridge/fullscreen';
import { showChatbox } from 'src/integrations/chatbox';
import TermsConditionsModal from 'src/components/views/subscription-v3/terms-conditions-modal';
import * as subscriptionV3Actions from 'src/stores/actions/subscription-v3-actions';

class ProcessAddon extends Component<WithI18nProps> {
  state = {
    activeModalStatus: false,
    infoStatus: {},
    activeTermsConditionsModal: false,
    termsConditionsContent: ''
  };
  async componentDidMount() {
    const { addon = {}, getAddonStatus } = this.props;
    const addonName = _.get(addon, 'addonName', '');
    if (_.includes(addonName, 'analytics')) {
      await getAddonStatus(addonName);
    }
  }

  componentWillReceiveProps(nextProps) {
    const { verifying: verifyingPrev } = this.props;
    const { verifying, termsConditions } = nextProps;
    if (verifyingPrev === true && verifying === false && termsConditions) {
      const termsConditionsContent = _.get(termsConditions, 'content', '');
      this.setState({ termsConditionsContent });
    }
  }
  render() {
    const { activeModalStatus, infoStatus, activeTermsConditionsModal, termsConditionsContent } =
      this.state;
    const {
      addon = {},
      handleAfterSubscribeAddon,
      openModalReview,
      handleReviewModal,
      hadSubscribed,
      analytic
    } = this.props;

    return (
      <>
        <ReviewModal
          active={openModalReview}
          addon={addon}
          hadSubscribed={hadSubscribed}
          handleCancel={handleReviewModal}
          handleOpenStatus={this.handleOpenStatus}
          handledTermNCondition={this.handledTermNCondition}
          analyticInput={analytic}
        />
        <StatusModal
          active={activeModalStatus}
          infoStatus={infoStatus}
          secondaryAction={this.handleSupport}
          handleCancel={() => {
            this.toggleModal('activeModalStatus');
            if (infoStatus.status === 'success') handleAfterSubscribeAddon();
          }}
        />
        <TermsConditionsModal
          active={activeTermsConditionsModal}
          handleChangeModal={this.handledTermNCondition}
          content={termsConditionsContent}
          onlyView={true}
        />
      </>
    );
  }

  // Open modal status success/error after subscribe
  handleOpenStatus = status => {
    const { addon, handleAfterSubscribeAddon, handleReviewModal, addonSubscribed } = this.props;
    let infoStatus = {};
    if (status === 'success') {
      infoStatus = {
        status,
        addonTitle: addon.title,
        handleAction: () => {
          handleAfterSubscribeAddon();
          this.handleClose();
        }
      };
    } else {
      infoStatus = {
        status,
        handleAction: () => {
          this.toggleModal('activeModalStatus');
          handleReviewModal();
        }
      };
    }
    if (addonSubscribed.confirmationUrl) {
      window.top.location.href = addonSubscribed.confirmationUrl;
    } else {
      handleReviewModal();

      this.setState({ infoStatus, activeModalStatus: true });
    }
  };

  handledTermNCondition = () => {
    this.toggleModal('activeTermsConditionsModal');
    this.props.handleReviewModal();
  };
  // Toggle modal
  toggleModal = fieldName => {
    const value = this.state[fieldName];
    this.setState({ [fieldName]: !value });
  };
  // Handle back to subscription page
  handleClose = () => {
    const { keepFullscreen = false } = this.props;
    this.toggleModal('activeModalStatus');
    this.props.getDetailInvoice();
    if (!keepFullscreen) {
      exitSABFullscreen();
    }
  };

  // Open beacon chat
  handleSupport = () => {
    this.setState({ activeModalStatus: false });
    showChatbox();
  };
}

const mapDispatchToProps = (dispatch, ownProps) => ({
  getAddonStatus: addonName => dispatch(subscriptionV3Actions.getAddonStatus(addonName)),
  getDetailInvoice: () => dispatch(subscriptionV3Actions.getDetailInvoice(ownProps.i18n))
});

const mapStateToProps = (state, props) => {
  const tenantApp = _.get(state.oauth, 'tenantApp', {});
  const invoiceSubscribed = _.get(state.subscriptionV3, 'invoice', {});

  return {
    invoiceSubscribed,
    tenantApp,
    statusStore: _.get(state.oauth, 'subscription.status', ''),
    gettingInvoice: _.get(state.subscriptionV3, 'gettingInvoice', false),
    getInvoiceSuccess: _.get(state.subscriptionV3, 'getInvoiceSuccess', false),
    verifying: _.get(state.subscriptionV3, 'verifying', false),
    termsConditions: _.get(state.subscriptionV3, 'termsConditions', ''),
    addonSubscribed: _.get(state.subscriptionV3, 'addonSubscribed', false)
  };
};

export default withI18n()(connect(mapStateToProps, mapDispatchToProps)(ProcessAddon));
